import { Link } from "react-router-dom";

// Tekst met interne links in de vorm [label](/pad).
export const RichText = ({ text }) =>
  text.split(/(\[[^\]]+\]\([^)]+\))/g).map((part, i) => {
    const m = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    return m
      ? <Link key={i} to={m[2]} className="font-semibold text-maas underline decoration-maas/30 underline-offset-4 hover:decoration-maas">{m[1]}</Link>
      : part;
  });
